import React, { useRef, useEffect, useState } from "react";
import SupportAvatar from "../assets/images/support-avatar.svg";
import BackIcon from "../components/svg/BackIcon";
import { Link } from "react-router-dom";

import { generateKey } from "../helper/helper";
import SupportFooter from "../components/SupportFooter";
// eslint-disable-next-line
let messagesEnd: any = null;

const ChatSupport = () => {
  const [allMessage, setAllMessage] = useState([]) as any;

  const scrollBottom = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    scrollBottom.current!.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, []);

  const renderMessage = allMessage.map((item: any) => {
    return <React.Fragment key={generateKey(item.props.message)}>{item}</React.Fragment>;
  });

  return (
    <div className="chat-support">
      <div className="chat-support__head">
        <div className="chat-support__head__holder">
          <div className="chat-support__head__holder__avatar">
            <img src={SupportAvatar} alt="support-avatar" />
          </div>
          <div className="chat-support__head__holder__title">
            <h5>عدم امکان دسترسی به بخش اصناف</h5>
            <h6>بهداشت</h6>
          </div>
          <div className="chat-support__head__holder__back">
            <Link to="/setting/support">
              <BackIcon />
            </Link>
          </div>
        </div>
        <div className="line2" />
      </div>

      <div className="chat-support__body">
        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            سلام
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        <div className="i-msg-holder">
          <div className="i-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="i-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>
        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>
        <div className="i-msg-holder">
          <div className="i-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="i-msg-holder__date">
              <span>20 : 16</span>
            </div>
          </div>
        </div>
        <div className="i-msg-holder">
          <div className="i-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="i-msg-holder__date">
              <span>20 : 16</span>
            </div>
          </div>
        </div>
        <div className="support-msg-holder">
          <div className="support-msg-holder__content">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است .
            <div className="support-msg-holder__date">
              <span>20:16</span>
            </div>
          </div>
        </div>

        {renderMessage}
        <p ref={scrollBottom} />
      </div>
      <SupportFooter
        allMessage={allMessage}
        setAllMessage={setAllMessage}
        scrollToBottom={scrollToBottom}
      />
    </div>
  );
};

export default ChatSupport;
